import React from 'react';
import styled from 'styled-components';
import Loader from 'components/Loader/Loader';
import InlineButtonWithStatus from './InlineButtonWithStatus';
import type IInlineButtonWithSpinner from './shared/types/inlineButtonWithSpinner';

const Pending = styled.div`
    position: relative;
`;

const ChildrenWrapper = styled.span<any>`
    visibility: hidden;
`;

const StyledSpinner = styled(Loader)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const InlineButtonWithSpinner = React.forwardRef<HTMLAnchorElement | HTMLButtonElement, IInlineButtonWithSpinner>(
    ({ spinner = <StyledSpinner size={16} />, children, ...restProps }, ref) => (
        <InlineButtonWithStatus
            ref={ref}
            onIdle={children}
            onPending={
                <Pending>
                    {spinner}
                    <ChildrenWrapper>{children}</ChildrenWrapper>
                </Pending>
            }
            {...restProps}
        />
    )
);

export default InlineButtonWithSpinner;
